<template>
  <b-card>
    <div style="font-size: 12px">
      <div class="title">
        <span>Cadastro de Curso</span>
        <span class="requiredFields">* Campos Obrigatórios</span>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cash-stack /> Informações Gerais</span>
        <div class="rowContent">
          <div class="contentImg">
            <div class="leftImg">
              <div>
                <label class="logo" for="input_file">
                  <span
                    style="
                      width: 100%;
                      height: 100%;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <img
                      v-if="!urlPhoto && !imgBase64"
                      :class="`${classImg} imageCustomer`"
                      :src="notImg"
                    />
                    <img
                      v-else
                      :hidden="!urlPhoto && !imgBase64"
                      :class="`${classImg} imageCustomer`"
                      :src="
                        imgBase64
                          ? imgBase64
                          : `${urlPhoto}?timestamp=${Date.now()}`
                      "
                    />
                  </span>
                </label>
                <input type="file" id="input_file" @change="selectImage" />
                               <!-- <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" @change="changeimage" /> -->
              </div>
              <span class="user-label-img">
                <b-icon-images></b-icon-images> Selecione a Imagem
              </span>
            </div>
            <div class="rightImg">
              <div class="rowContentImgName">
                <div class="input-group-img">
                  <input
                    required
                    :class="`borderInput ${isInvalidInput}`"
                    v-model="dataCourse.name"
                    ref="nome"
                    @blur="clearInvalidInput"
                  />
                  <label class="fixedSelect3">
                    Nome <span class="validRed">*</span>
                  </label>
                </div>
                <div class="input-group-img" style="width: 15% !important">
                  <input
                    type="date"
                    class="borderInput"
                    v-model="dataCourse.startDate"
                  />
                  <label class="fixedSelect3"> Data de Início </label>
                </div>
                <div class="input-group-img" style="width: 15% !important">
                  <input
                    type="date"
                    class="borderInput"
                    v-model="dataCourse.endDate"
                  />
                  <label class="fixedSelect3"> Data de Fim </label>
                </div>
              </div>
              <div class="rowContentImgName">
                <div class="input-group-img" style="position: relative">
                  <input
                    required
                    class="borderInput"
                    v-model="dataCourse.pix"
                  />
                  <label class="fixedSelect3"> Chave Pix </label>
                  <b-button class="btnPix" @click="gerarPix"
                    >Gerar Pix
                  </b-button>
                </div>
              </div>
              <div class="rowContentImgName">
                <div class="input-group-img" style="width: 25% !important">
                  <input
                    required
                    class="borderInput"
                    v-model="dataCourse.studantsLimit"
                  />
                  <label class="fixedSelect3"> Limite de Alunos </label>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    bottom: 20px;
                    position: relative;
                  "
                >
                  <div class="text-h6" style="color: #666">Período</div>
                  <div class="radio-input">
                    <label>
                      <input
                        type="radio"
                        id="value-1"
                        name="value-radio"
                        value="Manhã"
                        v-model="dataCourse.periodo"
                      />
                      <span>Manhã</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        id="value-2"
                        name="value-radio"
                        value="Tarde"
                        v-model="dataCourse.periodo"
                      />
                      <span>Tarde</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        id="value-3"
                        name="value-radio"
                        value="Noite"
                        v-model="dataCourse.periodo"
                      />
                      <span>Noite</span>
                    </label>
                    <span class="selection"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cash-stack /> Pagamento Curso</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              @input="assingpricingTotal($event)"
              :value="maskCurrency(dataCourse.pricingTotal)"
            />
            <label class="user-label"> Preço Á vista </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              @input="assingprice($event)"
              :value="maskCurrency(dataCourse.price)"
            />
            <label class="user-label"> Preço Á prazo </label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect">Quantidade de Parcelas</label>
            <b-form-select
              value-field="value"
              text-field="text"
              class="borderInput shadow-none"
              :options="typesInstallment"
              v-model="dataCourse.qtdInstallments"
              size="sm"
            >
            </b-form-select>
          </div>

          <div class="input-group">
            <input
              required
              class="input borderInput"
              @input="assingpricingInstallments($event)"
              :value="maskCurrency(dataCourse.pricingInstallments)"
            />
            <label class="user-label"> Valor das Parcelas </label>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-book /> Pagamento Material</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              @input="assingmaterialPrice($event)"
              :value="maskCurrency(dataCourse.materialPrice)"
            />
            <label class="user-label"> Preço Á vista </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              @input="assingmaterialPriceOmega($event)"
              :value="maskCurrency(dataCourse.materialPriceOmega)"
            />
            <label class="user-label"> Preço Á prazo </label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect">Quantidade de Parcelas</label>
            <b-form-select
              value-field="value"
              text-field="text"
              class="borderInput shadow-none"
              :options="typesInstallment"
              v-model="dataCourse.qtdInstallmentsMaterialOmega"
              size="sm"
            >
            </b-form-select>
          </div>

          <div class="input-group">
            <input
              required
              class="input borderInput"
              @input="assingpricingInstallmentsMaterialOmega($event)"
              :value="maskCurrency(dataCourse.pricingInstallmentsMaterialOmega)"
            />
            <label class="user-label"> Valor das Parcelas </label>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-info-circle /> Descrição do Curso</span>
        <div class="rowContent">
          <div
            style="display: flex; flex-direction: column; gap: 5px; width: 100%"
          >
            <textarea
              class="inputTextArea"
              rows="3"
              max-rows="6"
              v-model="dataCourse.description"
            />
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-info-circle-fill /> Dados do Contrato</span>
        <div class="rowContent">
          <div>
            <p>@nomeAluno = Nome do aluno</p>
            <p>@nomeCurso = Nome do curso</p>
            <p>@precoCurso = Preço do curso</p>
            <p>@precoMaterialCurso = Preço do material externo</p>
            <p>@precoMaterialOmegaCurso = Preço do material interno</p>
          </div>
          <div>
            <p>@dataInicioCurso = Data de início do curso</p>
            <p>@dataFimCurso = Data de fim do curso</p>
            <p>@nomeContratante = Nome do contratante</p>
            <p>@cpfContratante = CPF do contratante</p>
            <p>@rgContratante = RG do contratante</p>
          </div>
          <div>
            <p>@emailContratante = Email do contratante</p>
            <p>@nomeFiador = Nome do fiador</p>
            <p>@cpfFiador = CPF do fiador</p>
            <p>@rgFiador = RG do fiador</p>
            <p>@emailFiador = Email do fiador</p>
          </div>
        </div>
      </div>
      <div class="rowContainer" style="margin-bottom: 60px">
        <div class="rowContent">
          <div class="pa-md">
            <div class="expansion-item">
              <div
                :class="['header', { 'bg-primary text-white': isOpen }]"
                @click="toggleEditor"
              >
                <span> <b-icon-plus-square-fill /> Editor de contrato</span>
                <i class="material-icons" :class="{ 'text-white': isOpen }">
                </i>
              </div>
              <transition name="slide">
                <div v-if="isOpen" class="editor-content" @focusin.stop>
                  <vue-editor
                    v-model="editorContent"
                    :editor-toolbar="toolbarOptions"
                    :editor-fonts="fonts"
                    :style="{ fontSize: '12px' }"
                  />
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <div>
          <div class="btnsContainer">
            <b-button class="btnsSaveNeutral" @click="clearInputs"
              >Novo
              <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise
            ></b-button>
            <!-- <b-button
              class="btnsSave"
              v-if="dataCourse.isStarting"
              @click="openDelete"
              >Finalizar Curso
            </b-button>
            <b-button class="btnsSave" v-else @click="openStart"
              >Iniciar Curso
            </b-button> -->
            <b-button class="btnsSave" @click="saveOrUpdateCourse"
              >{{ dataCourse.id ? "Atualizar" : "Salvar" }}
            </b-button>
          </div>
        </div>
      </div>
      <b-modal id="modal-close" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Finalizar Curso</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O curso selecionado esta prestes a ser finalizado!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmDelete"
                name="checkbox-1"
              >
                Estou ciente e desejo finalizar.
              </b-form-checkbox>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-close')">
              Não
            </button>
            <button
              class="btnConfirm"
              @click="finishCourse"
              style="position: relative"
            >
              Sim, finalizar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-start" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Iniciar Curso</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O curso selecionado esta prestes a ser iniciado!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmStart"
                name="checkbox-1"
              >
                Estou ciente e desejo Iniciar.
              </b-form-checkbox>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-start')">
              Não
            </button>
            <button
              class="btnConfirm"
              @click="startCourse"
              style="position: relative"
            >
              Sim, Iniciar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import mixinCourse from "../../mixins/Course/Course";

export default {
  mixins: [mixinCourse],
};
</script>
<style scoped>
.pa-md {
  padding: 16px;
  width: 100%;
}

.editor-content {
  font-size: 13px !important;
}
.expansion-item {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
}

.editor-content {
  padding: 16px;
}

.material-icons {
  font-size: 13px !important;
}

.editor-content p {
  font-size: 13px !important;
}
p {
  font-size: 13px !important;
}

.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6,
.ql-editor ol,
.ql-editor p,
.ql-editor pre,
.ql-editor ul {
  font-size: 12px !important;
}

.ql-editor {
  font-size: 12px !important;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.content-btn-fixed {
  width: 100%;
  padding: 0.7% 0px;
  left: 60px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffff;
  z-index: 10;
  box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);
}

.tamanhoBotaoOpenCard {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.tamanhoBotaoOpenCardFinaly {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.iconCadTransportadora {
  display: flex;
  justify-content: space-between;
}

.btnCadTransportadora {
  cursor: pointer;
}

.cardDadosMdfe {
  padding-bottom: 15px !important;
  border-radius: 5px !important;
  border: 1px solid rgba(232, 231, 231, 0.788);
  background-color: #f9f9f94d !important;
  padding: 0px 0px 0px 0px !important;
  border-radius: 5px !important;
  width: 100%;
}

.cardDadosMdfeBorda {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.cardDadosMdfeBordaDupli {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: rgb(213, 213, 213);
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: context-menu;
}

.description {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 100px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.description p {
  margin: 0px;
  color: #666360;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.descriptionObs {
  color: #666360a3;
}

.contentImg {
  display: flex;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 10px;
  gap: 20px;
  position: relative;
}

.rightImg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  position: relative;
}

.image-container {
  width: 20%;
}

.input-container {
  width: 80%;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.input-group {
  width: 100%;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.contentImg > div {
  display: flex;
}

.contentImg .logo {
  height: 150px;
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 7px;
  border: solid 1px rgb(223 223 223);
  color: #aaa;
  cursor: pointer;
  margin: 0;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.contentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.subTitle {
  color: #767676;
  font-size: 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  margin: 0;
}

.titleModalReversalOrDelete {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitle {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActions {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirm {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancel {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

.input-group {
  width: 100%;
}

.logo_img_not {
  height: 148px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
}

#input_file {
  display: none;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.imageCourse {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 10px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.contentImg {
  display: flex;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 10px;
  gap: 20px;
  position: relative;
}

.leftImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.image-container {
  width: 20%;
}

.imageCustomer {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.input-container {
  width: 80%;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.user-label-img {
  position: absolute;
  left: 10px;
  width: 19%;
  text-align: center;
  bottom: 25px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
.input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}
.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  left: 3px;
  font-size: 11px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  bottom: 13px;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  background-color: #ffff;
  padding: 0 0.2em;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(https://cdn-icons-png.flaticon.com/512/271/271210.png)
    right 0.75rem center / 8px 10px no-repeat !important;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.radio-input {
  display: flex;
}

.radio-input input {
  display: none;
}

.input-group-img {
  height: 30px;
  width: 100%;
}

.radio-input {
  --container_width: 330px;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  color: #707070;
  width: var(--container_width);
  overflow: hidden;
  border: 1px solid rgba(53, 52, 52, 0.226);
}

.rowContentImgName {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  gap: 10px;
}

.radio-input label {
  width: 100%;
  padding: 5px 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 11px;
  margin-bottom: 0px !important;
}

.selection {
  display: none;
  position: absolute;
  height: 100%;
  width: calc(var(--container_width) / 3);
  z-index: 0;
  left: 0;
  top: 0;
  transition: 0.15s ease;
}

.radio-input label:has(input:checked) {
  color: #fff;
}

.radio-input label:has(input:checked) ~ .selection {
  background-color: #3a4750;
  display: inline-block;
}

.radio-input label:nth-child(1):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 0 / 3));
}

.radio-input label:nth-child(2):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 1 / 3));
}

.radio-input label:nth-child(3):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 2 / 3));
}

.selectPlusImg {
  position: relative;
  width: 23%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect3 {
  position: relative;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 40px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect4 {
  position: relative;
  margin-bottom: 0px;
  font-size: 9px !important;
  bottom: 36px;
  width: 50px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  width: 100%;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

p {
  margin-bottom: 0rem !important;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.rowContentImg {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 10px;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  display: flex;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: white;
  padding: 20px;
  justify-content: space-evenly;
}

.btnsSave {
  border-radius: 5px;
  background-color: #0188c8;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnPix {
  border-radius: 0 5px 5px 0;
  background-color: #0188c8;
  width: 100px;
  height: 30px;
  position: absolute;
  right: 0px;
  top: 0px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.input-group {
  width: 30%;
}

.input-group-ob {
  width: 65%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .contentImg {
    flex-direction: column;
  }

  .rightImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    flex-direction: column;
  }

  .rowContentImg {
    display: flex;
    width: 100%;
    gap: 0px;
    flex-direction: column;
    align-items: center;
  }

  .input-group {
    width: 100%;
  }

  .input-group-img {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .borderInput {
    width: 100%;
  }

  .selectPlusImg {
    width: 100%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
}
</style>
